import { render } from "./RegionsView.vue?vue&type=template&id=28dfe6ce"
import script from "./RegionsView.vue?vue&type=script&lang=js"
export * from "./RegionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__